import { Component, EventEmitter, Input, Output } from '@angular/core';
import AdjustmentInvoice from 'src/app/model/invoice/adjustment-invoice';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';

@Component({
  selector: 'ip-board-adjustment-company-invoice',
  templateUrl: './ip-board-adjustment-company-invoice.component.html',
  styleUrls: ['./ip-board-adjustment-company-invoice.component.scss']
})
export class IPBoardAdjustmentCompanyInvoiceComponent {
  @Input()
  adjustmentInvoice: AdjustmentInvoice;
  @Input()
  multiple: boolean;
  @Input()
  showSave = false;
  @Input()
  savingLines = false;
  @Output()
  save = new EventEmitter<any>();
  @Output()
  saveLines = new EventEmitter();

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  emitSave() {
    this.save.emit();
    this.projectDisplayObservableService
      .getProjectInvoicePriceChangedSubscribable()
      .next();
  }
}
